import { FindDocumentsOverlay } from '@client/components/compliance-audit/find-documents/FindDocumentsOverlay';
import { ENABLE_AUDIT_DOCUMENT_SOURCES_FLAG } from '@shared/constants/business/document-sources';
import { createFileRoute } from '@tanstack/react-router';

// CUR-2564 — Find documents: search the organisation's connected SharePoint for this audit's
// documents and add copies to it. Opened from the Library header; rendered through the detail
// route's <Outlet /> so the audit stays visible behind it.
export const Route = createFileRoute(
    '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/find-documents',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Find documents',
        },
        // `RouteAccessGuard` answers a direct link with Not found while the flag is off, once flags
        // have settled for the signed-in user and organisation. A UI gate only: every document
        // sources procedure checks the flag and the audit permissions on the server.
        featureFlag: ENABLE_AUDIT_DOCUMENT_SOURCES_FLAG,
    },
    component: RouteComponent,
});

function RouteComponent() {
    return <FindDocumentsOverlay complianceAuditId={Route.useParams().complianceAuditId} />;
}
